import type { Application } from "pixi.js";

/**
 * 固定タイムステップの tick ループ。
 * Pixi v8 の Ticker を利用し、速度倍率に応じた dt（秒）を渡す。
 */
export type TickFn = (dtSeconds: number) => void;

export interface TickerController {
  start(): void;
  stop(): void;
  setSpeed(multiplier: number): void;
  setRunning(running: boolean): void;
  dispose(): void;
}

export function createTicker(app: Application, onTick: TickFn): TickerController {
  const state = {
    running: false,
    speed: 1,
  };

  const listener = (t: { deltaMS: number }) => {
    if (!state.running) return;
    const dt = (t.deltaMS / 1000) * state.speed;
    // 極端な dt（タブ復帰時など）を 0.1s でクランプ
    onTick(Math.min(dt, 0.1));
  };

  app.ticker.add(listener);

  return {
    start() {
      state.running = true;
    },
    stop() {
      state.running = false;
    },
    setSpeed(multiplier: number) {
      state.speed = Math.max(0, multiplier);
    },
    setRunning(running: boolean) {
      state.running = running;
    },
    dispose() {
      app.ticker.remove(listener);
    },
  };
}
